module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-large.ed9e2d78.jpg";